module.exports = __webpack_public_path__ + "media/assets/images/logo_coe2-12e1e16e7474e866880189cee00f09ed.png";